var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import merge from 'lodash/merge';
import { ZodError } from 'zod';
var FetchError = /** @class */ (function (_super) {
    __extends(FetchError, _super);
    function FetchError(_a) {
        var message = _a.message, data = _a.data, status = _a.status;
        var _this = _super.call(this, message) || this;
        _this.status = status;
        _this.data = data;
        return _this;
    }
    FetchError.getFetchError = function (error) {
        if (isFetcherError(error))
            return error;
        return undefined;
    };
    return FetchError;
}(Error));
export { FetchError };
var FetchValidationError = /** @class */ (function (_super) {
    __extends(FetchValidationError, _super);
    function FetchValidationError(_a) {
        var message = _a.message, data = _a.data, errors = _a.errors;
        var _this = _super.call(this, message) || this;
        _this.data = data;
        _this.errors = errors;
        console.error(message, errors.format());
        return _this;
    }
    return FetchValidationError;
}(Error));
export { FetchValidationError };
var isObject = function (x) { return typeof x === 'object' && x !== null; };
export var isFetcherError = function (error) {
    if (error instanceof FetchError)
        return true;
    if (isObject(error) && 'status' in error && 'data' in error && 'message' in error) {
        var status_1 = error.status;
        return typeof status_1 === 'number';
    }
    return false;
};
export var isFetchValidationError = function (error) {
    if (error instanceof FetchValidationError)
        return true;
    return (isObject(error) &&
        'data' in error &&
        'errors' in error &&
        'message' in error &&
        !('status' in error));
};
function getFilenameFromContentDisposition(header) {
    var _a;
    if (!header)
        return undefined;
    var match = /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i.exec(header);
    var raw = (_a = match === null || match === void 0 ? void 0 : match[1]) !== null && _a !== void 0 ? _a : match === null || match === void 0 ? void 0 : match[2];
    if (!raw)
        return undefined;
    try {
        return decodeURIComponent(raw);
    }
    catch (_b) {
        return raw;
    }
}
function toUrlString(u) {
    if (!u)
        return undefined;
    return u instanceof URL ? u.href : u;
}
export function createFetcher(defaultFetcherConfig) {
    function fetcher(url, fetcherOptions) {
        return __awaiter(this, void 0, void 0, function () {
            var fetcherOptionsWithDefaults, baseUrl, fetcherUrl, response, contentType, contentDisposition, shouldBlobExplicit, shouldBlobImplicit, data, blob, filename, canUseFile, backup, _a, e_1, should422Throw;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        fetcherOptionsWithDefaults = (defaultFetcherConfig === null || defaultFetcherConfig === void 0 ? void 0 : defaultFetcherConfig.options)
                            ? merge({}, (function () {
                                var opts = defaultFetcherConfig.options;
                                return typeof opts === 'function' ? opts() : opts;
                            })(), fetcherOptions.options)
                            : fetcherOptions.options;
                        baseUrl = (function () {
                            var current = defaultFetcherConfig === null || defaultFetcherConfig === void 0 ? void 0 : defaultFetcherConfig.baseUrl;
                            return typeof current === 'function' ? current() : current;
                        })();
                        fetcherUrl = (function () {
                            var _a;
                            var baseStr = toUrlString(baseUrl);
                            if (!baseStr)
                                return url;
                            var base = baseStr.replace(/\/+$/, '');
                            var path = ((_a = toUrlString(url)) !== null && _a !== void 0 ? _a : '').replace(/^\/+/, '');
                            return "".concat(base, "/").concat(path);
                        })();
                        return [4 /*yield*/, fetch(fetcherUrl, fetcherOptionsWithDefaults)];
                    case 1:
                        response = _c.sent();
                        if (response.status === 204 || response.status === 205) {
                            if (!response.ok) {
                                throw new FetchError({
                                    status: response.status,
                                    message: response.statusText,
                                    data: null,
                                });
                            }
                            if ('skipValidation' in fetcherOptions && fetcherOptions.skipValidation) {
                                return [2 /*return*/, null];
                            }
                            try {
                                return [2 /*return*/, fetcherOptions.successSchema.parse(null)];
                            }
                            catch (error) {
                                if (error instanceof ZodError) {
                                    throw new FetchValidationError({
                                        message: 'Validation failed',
                                        data: null,
                                        errors: error,
                                    });
                                }
                                throw error;
                            }
                        }
                        contentType = (_b = response.headers.get('content-type')) !== null && _b !== void 0 ? _b : '';
                        contentDisposition = response.headers.get('content-disposition');
                        shouldBlobExplicit = fetcherOptions.responseType === 'blob';
                        shouldBlobImplicit = !!contentDisposition ||
                            /application\/pdf/i.test(contentType) ||
                            /application\/octet-stream/i.test(contentType);
                        data = null;
                        if (!(shouldBlobExplicit || shouldBlobImplicit)) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.blob()];
                    case 2:
                        blob = _c.sent();
                        filename = getFilenameFromContentDisposition(contentDisposition);
                        canUseFile = typeof File !== 'undefined';
                        data =
                            filename && canUseFile
                                ? new File([blob], filename, { type: blob.type || undefined })
                                : blob;
                        return [3 /*break*/, 11];
                    case 3:
                        backup = response.clone();
                        _c.label = 4;
                    case 4:
                        _c.trys.push([4, 6, , 11]);
                        return [4 /*yield*/, response.json()];
                    case 5:
                        data = _c.sent();
                        return [3 /*break*/, 11];
                    case 6:
                        _a = _c.sent();
                        _c.label = 7;
                    case 7:
                        _c.trys.push([7, 9, , 10]);
                        return [4 /*yield*/, backup.text()];
                    case 8:
                        data = _c.sent();
                        return [3 /*break*/, 10];
                    case 9:
                        e_1 = _c.sent();
                        console.error(e_1);
                        data = null;
                        return [3 /*break*/, 10];
                    case 10: return [3 /*break*/, 11];
                    case 11:
                        should422Throw = fetcherOptions.throw422 && response.status === 422;
                        if (!response.ok && (response.status !== 422 || should422Throw)) {
                            throw new FetchError({
                                status: response.status,
                                message: response.statusText,
                                data: data,
                            });
                        }
                        if ('skipValidation' in fetcherOptions && fetcherOptions.skipValidation) {
                            return [2 /*return*/, data];
                        }
                        try {
                            return [2 /*return*/, fetcherOptions.successSchema.parse(data)];
                        }
                        catch (error) {
                            if (error instanceof ZodError) {
                                throw new FetchValidationError({
                                    message: 'Validation failed',
                                    data: data,
                                    errors: error,
                                });
                            }
                            throw error;
                        }
                        return [2 /*return*/];
                }
            });
        });
    }
    return fetcher;
}
